
import { StringOrPhoneNumber } from "./common.model";
import { MonthlyInvoiceStatus, SelectType } from "./constants";
import { Field, ObjectType } from "./decorators";
import { DiscountSummary } from "./discount.model";

/**
 * Model that shares a lot of billing order but is different enough.
 */

@ObjectType()
export class MonthlyInvoiceLine {

  @Field({q:['all','sd']}) public monthlyInvoiceLineId?: number;
  @Field() public monthlyInvoiceId?: number;
  @Field({q:['all','sd']}) public scId?: number;
  @Field({q:['all','sd']}) public startDate?: Date;
  @Field({q:['all','sd']}) public endDate?: Date;
  @Field({q:['all','sd']}) public selectType?: SelectType;
  @Field({q:['all','sd']}) public price?: number;
  @Field() public listPrice?: number;
  @Field() public discountAmount?: number;
  @Field() public discountList?: DiscountSummary[];
  @Field() public description?: string;
  @Field() public unitPrice?: number;
  @Field() public quantity?: number;
  @Field({q:['all','sd']}) public leaseOrderId?: number;
  @Field({q:['all','sd']})public leaseEndDate?: Date;
  @Field({q:['all','sd']}) public leaseMonth?: number;
}




@ObjectType()
export class MonthlyInvoice {

  @Field({q:['all','sd']}) public monthlyInvoiceId!: number;
  @Field({q:['all','sd']}) public accountId?: number;
  @Field({q:['all','sd']}) public company?: string;
  @Field({q:['all','sd']}) public invoiceStatus?: MonthlyInvoiceStatus;
  @Field() public latestInvoice?: boolean;
  @Field() public parentInvoiceId?: number;
  @Field({q:['all','sd']}) public numberOfCodes = 0;
  @Field({q:['all','sd']}) public totalPrice = 0;
  @Field({q:['all','sd']}) public startDate?: Date;
  @Field({q:['all','sd']}) public endDate?: Date;
  @Field({q:['all','sd']}) public paymentDueDate?: Date;
  @Field({q:['all','sd']}) public paymentReceivedDate?: Date;
  @Field({q:['all','sd']}) public paymentMethod?: string;
  @Field() public lastFourDigits?: string;
  @Field() public checkNumber?: string;
  @Field() public ccFailedComment?: string;
  @Field() public poNumber?: string;
  @Field() public nsInvoiceInternalId?: string;
  @Field() public nsPaymentInternalId?: string;
  @Field() public createTime?: Date;
  @Field() public updateTime?: Date;
  @Field() public invoiceDate?: Date;
  @Field() public originalInvoiceDate?: Date;
  @Field() public invoiceDocumentId?: number;
  @Field() public receiptDocumentId?: number;
  @Field() public billingFirstName?: string;
  @Field() public billingLastName?: string;
  @Field() public billingAddress1?: string;
  @Field() public billingAddress2?: string;
  @Field() public billingCity?: string;
  @Field() public billingZip?: string;
  @Field() public billingCountry?: string;
  @Field() public billingState?: string;
  @Field() public billingPhone?: StringOrPhoneNumber;
  @Field() public billingPhoneExtension?: string;
  @Field() public billingEmail?: string;

  public lines: MonthlyInvoiceLine[] = [];


  // client only
  public isExpansionDisplay?: boolean;

}
